import * as React from 'react';
import { Lightbox } from './Lightbox';
import useLightboxStore from './store';

const LightboxContainer: React.FunctionComponent = () => {
  const { lightbox } = useLightboxStore();
  if (lightbox.length === 0) return null;

  return (
    <>
      {lightbox.map((item) => {
        if ('render' in item) {
          return item.render({ id: item.id, show: true });
        }
        return <Lightbox key={item.id || item.title} {...item} />;
      })}
    </>
  );
};

export default LightboxContainer;
